/*
* Broadcast Theme — Swatch King Image Swap Fix v4
*
* O Swatch King usa option-value-id nos seus swatches que corresponde
* ao ID da variante por opção. Quando clicado, precisamos encontrar
* a variante correta e atualizar o input[name="id"] do Broadcast,
* depois disparar o evento change para que o tema processe a troca de imagem.
*/

(function() {

  function initFix() {
    document.addEventListener('click', function(e) {
      var swatchEl = e.target.closest('[option-value-id][swatch-option]');
      if (!swatchEl) return;

      // option-value-id é o ID da variante correspondente a esta opção
      var optionValueId = swatchEl.getAttribute('option-value-id');
      var optionName = swatchEl.getAttribute('swatch-option'); // "option1"
      var optionValue = swatchEl.getAttribute('data-value') || swatchEl.getAttribute('orig-value');

      if (!optionValueId || !optionValue) return;

      // Pequeno delay para o Swatch King terminar primeiro
      setTimeout(function() {

        // 1. Atualiza o radio button nativo do Broadcast
        var radios = document.querySelectorAll(
          '[data-single-option-selector][data-index="' + optionName + '"]'
        );
        radios.forEach(function(radio) {
          if (radio.value === optionValue && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // 2. Tenta encontrar a variante completa via product JSON e atualizar input[name="id"]
        var productJsonEl = document.querySelector('[data-product-json]');
        if (!productJsonEl) return;

        var productData;
        try { productData = JSON.parse(productJsonEl.textContent); } catch(e) { return; }
        if (!productData || !productData.variants) return;

        // Encontra a variante que contém este option-value-id
        // O option-value-id no Swatch King corresponde ao variant.id da primeira variante
        // com esse valor de opção
        var selectedVariant = null;
        var optionIndex = parseInt(optionName.replace('option', '')) - 1;

        // Primeiro tenta encontrar pelo option-value-id direto
        selectedVariant = productData.variants.find(function(v) {
          return v.id === parseInt(optionValueId);
        });

        // Se não encontrou, encontra a variante atual e procura a que tem este valor de opção
        if (!selectedVariant) {
          var idInput = document.querySelector('input[name="id"]');
          var currentVariantId = idInput ? parseInt(idInput.value) : null;
          var currentVariant = currentVariantId ? productData.variants.find(function(v) { return v.id === currentVariantId; }) : null;

          selectedVariant = productData.variants.find(function(v) {
            // Mantém os outros valores de opção iguais, muda só o clicado
            if (currentVariant) {
              for (var i = 0; i < v.options.length; i++) {
                if (i === optionIndex) {
                  if (v.options[i] !== optionValue) return false;
                } else {
                  if (v.options[i] !== currentVariant.options[i]) return false;
                }
              }
              return true;
            }
            return v.options[optionIndex] === optionValue;
          });
        }

        if (!selectedVariant) return;

        // 3. Atualiza o input[name="id"] com o novo variant ID
        var idInput = document.querySelector('input[name="id"]');
        if (idInput && idInput.value !== String(selectedVariant.id)) {
          idInput.value = selectedVariant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 4. Dispara o evento theme:variant:change que o Broadcast escuta
        var productComponent = document.querySelector('[data-section-type="product"]');
        if (productComponent) {
          productComponent.dispatchEvent(new CustomEvent('theme:variant:change', {
            detail: { variant: selectedVariant },
            bubbles: true
          }));
        }

        // 5. Dispara diretamente o updateProductImage via o mecanismo interno do Broadcast
        // encontrando a imagem da variante e disparando theme:media:select
        if (selectedVariant.featured_media) {
          var mediaId = selectedVariant.featured_media.id;
          var sectionId = productComponent ? productComponent.getAttribute('data-section-id') : null;
          var mediaEl = sectionId
            ? document.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]')
            : document.querySelector('[data-image-id="' + mediaId + '"]');

          if (mediaEl) {
            mediaEl.dispatchEvent(new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: { id: sectionId + '-' + mediaId }
            }));
          }
        }

      }, 80);

    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFix);
  } else {
    initFix();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initFix, 500);
  });

})();
